export type View = 'table' | 'board' | 'charts';

export const VIEW_VARIANTS: Record<string, View> = {
  TABLE: 'table',
  BOARD: 'board',
  CHARTS: 'charts',
};
